import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Contact.css';
import Hero from '../Hero/Hero';
import Typical from 'react-typical';
import ftmImage from '../../assets/ftm.png';

const Contact = ({ renderHero, userId }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    company: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`https://ftlm.org.tn/contacts`, formData);
      toast.success('Message envoyé avec succès !');
      setFormData({
        fullName: '',
        email: '',
        phoneNumber: '',
        company: '',
        message: '',
      });
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message :', error);
      toast.error('Échec de l\'envoi du message. Veuillez réessayer.');
    }
  };

  return (
    <div className="contact-pagee">
      <ToastContainer />

      {renderHero && <Hero />}

      <section className="contact-section" id="Contact">
        <div className="form-container">
          <h1 className="animated-title">
            <Typical loop={Infinity} steps={['Contactez-nous', 3000]} />
          </h1>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Nom complet</label>
              <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} required />
            </div>
            <div className="input-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="input-group">
              <label>Numéro de téléphone</label>
              <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} />
            </div>
            <div className="input-group">
              <label>Société</label>
              <input type="text" name="company" value={formData.company} onChange={handleChange} />
            </div>
            <div className="input-group">
              <label>Votre message</label>
              <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>
            </div>

            <input type="hidden" name="userId" value={userId} />
            <button type="submit" className="submit-btn">Envoyer</button>
          </form>
        </div>

        <div className="info-container">
          <h1>Informations et contact</h1>
          <p><strong>Forum Tunisien des Leaders Maghrébines FTLM</strong></p>
          <p>Tél : <a href="tel:+21629868808">+216 29 868 808</a></p>
          <p>Tél : <a href="tel:+21670685825">+216 70 685 825</a></p>
          <p>Email : <a href="mailto:contact@ftlm.org.tn">contact@ftlm.org.tn</a></p>
          <p>18 Rue John Keynes, Z.I Chotrana, la petite Ariana, Ariana, Tunisia</p>
        </div>
      </section>

      <section className="image-banner">
        <img src={ftmImage} alt="FTLM" />
      </section>

      <section className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d204095.34511711085!2d10.007441714212609!3d36.93841176160801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12e2cbac6ccf4015%3A0x34b8c1a750a22703!2sFTLM!5e0!3m2!1sfr!2stn!4v1706607723542!5m2!1sfr!2stn"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Localisation FTLM"
        ></iframe>
      </section>
    </div>
  );
};

export default Contact;
